/* Miniversos back-in-stock client. Dependency-free; configured by the
 * wishlist-init snippet (window.MV_WISHLIST_CFG.proxy / customerEmail).
 * Event-delegated on document because the form markup is re-rendered by
 * product-variant-listener on every variant change. */
(function () {
  'use strict';
  if (window.__mvBackInStock) return;
  window.__mvBackInStock = true;

  var CFG = window.MV_WISHLIST_CFG || { proxy: '/apps/wishlist', customerEmail: null };
  var ENDPOINT = CFG.proxy + '/back-in-stock';
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  // Survives variant swaps (which replace the input) so the typed email is not lost.
  var lastEmail = CFG.customerEmail || '';

  function rootOf(el) { return el && el.closest ? el.closest('[data-mv-back-in-stock]') : null; }

  function setMessage(root, text, isError) {
    var el = root.querySelector('[data-mv-bis-message]');
    if (!el) return;
    el.textContent = text || '';
    el.classList.toggle('!error', !!isError);
    el.hidden = !text;
  }

  function showSuccess(root, text) {
    var init = root.querySelector('[data-mv-bis-init]');
    var ok = root.querySelector('[data-mv-bis-success]');
    var okText = root.querySelector('[data-mv-bis-success-text]');
    if (init) init.hidden = true;
    if (okText) okText.textContent = text || '';
    if (ok) ok.hidden = false;
  }

  function submit(root) {
    if (!root) return;
    var input = root.querySelector('[data-mv-bis-email]');
    var button = root.querySelector('[data-mv-bis-submit]');
    var hp = root.querySelector('[data-mv-bis-hp]');
    if (!input || !button || button.disabled) return;

    var email = (input.value || '').trim();
    if (!EMAIL_RE.test(email)) { setMessage(root, root.dataset.tInvalid, true); input.focus(); return; }
    // Honeypot filled → bot. Pretend success, never call the API.
    if (hp && hp.value) { showSuccess(root, root.dataset.tSuccess); return; }

    lastEmail = email;
    var label = button.textContent;
    button.disabled = true;
    button.textContent = root.dataset.tSubmitting || label;
    root.classList.add('!loading');
    setMessage(root, '', false);

    fetch(ENDPOINT, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        variantId: root.dataset.variantId,
        productId: root.dataset.productId,
        email: email,
        locale: root.dataset.locale || null
      })
    })
      .then(function (response) {
        return response.json().catch(function () { return {}; })
          .then(function (body) { return { status: response.status, body: body }; });
      })
      .then(function (result) {
        if (result.status === 200 && result.body && result.body.ok) {
          showSuccess(root, result.body.duplicate ? root.dataset.tDuplicate : root.dataset.tSuccess);
          return;
        }
        if (result.status === 429) { setMessage(root, root.dataset.tRateLimited, true); return; }
        if (result.status === 400 || result.status === 422) {
          var msg = (result.body && result.body.message) || '';
          setMessage(root, /email/i.test(msg) ? root.dataset.tInvalid : root.dataset.tError, true);
          return;
        }
        setMessage(root, root.dataset.tError, true);
      })
      .catch(function () { setMessage(root, root.dataset.tError, true); })
      .then(function () {
        button.disabled = false;
        button.textContent = label;
        root.classList.remove('!loading');
      });
  }

  function prefill(scope) {
    if (!lastEmail) return;
    var inputs = (scope || document).querySelectorAll('[data-mv-bis-email]');
    Array.prototype.forEach.call(inputs, function (input) { if (!input.value) input.value = lastEmail; });
  }

  document.addEventListener('click', function (e) {
    var button = e.target && e.target.closest ? e.target.closest('[data-mv-bis-submit]') : null;
    if (!button) return;
    e.preventDefault();
    submit(rootOf(button));
  });

  // Enter inside our input must not submit the surrounding add-to-cart <form>.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target;
    if (!input || !input.matches || !input.matches('[data-mv-bis-email]')) return;
    e.preventDefault();
    submit(rootOf(input));
  });

  // product-variant-listener dispatches a bubbling `update` after swapping its
  // children for the newly selected variant; re-apply the remembered email.
  document.addEventListener('update', function (e) {
    if (e.target && e.target.tagName === 'PRODUCT-VARIANT-LISTENER') prefill(e.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { prefill(document); });
  } else {
    prefill(document);
  }
})();
